import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { HelpService } from 'src/app/_service/help.service';
import { MiscService } from '../../_service/misc.service';
@Component({
  selector: 'app-knowledge-base',
  templateUrl: './knowledge-base.component.html',
  styleUrls: ['./knowledge-base.component.css']
})
export class KnowledgeBaseComponent implements OnInit {
  title: any; treatCategory = []; helpData = []; dataLoaded: boolean = false; allTitle = [];
  constructor(public miscapi: MiscService, private helpapi: HelpService, private sharedapi: SharedService) { }

  ngOnInit(): void {
    this.getTreatmentCategory();
    this.sethelpData(this.title = 'Procto');
  }

  async getTreatmentCategory() {
    this.dataLoaded = false;
    await this.miscapi.getTreat_Category().subscribe((data: any) => {
      if (data.status) {
        this.dataLoaded = true;
        this.treatCategory = data.data;
      } else {
        this.treatCategory = [];
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async sethelpData(title) {
    await this.helpapi.getHelpData(title).subscribe((response: any) => {
      if (response.status) {
        this.helpData = response.data;
        this.allTitle = response.allTitle;

      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


}














